// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as PlusRouteImport } from './routes/plus'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppSplatRouteImport } from './routes/_app.$'
import { Route as AppAboutRouteImport } from './routes/_app.about'
import { Route as AppBookmarksRouteImport } from './routes/_app.bookmarks'
import { Route as AppDailyRouteImport } from './routes/_app.daily'
import { Route as AppEditorialStandardsRouteImport } from './routes/_app.editorial-standards'
import { Route as AppFeedRouteImport } from './routes/_app.feed'
import { Route as AppJoinRouteImport } from './routes/_app.join'
import { Route as AppLeaderboardRouteImport } from './routes/_app.leaderboard'
import { Route as AppPremiumRouteImport } from './routes/_app.premium'
import { Route as AppPrivacyPolicyRouteImport } from './routes/_app.privacy-policy'
import { Route as AppSearchRouteImport } from './routes/_app.search'
import { Route as AppTermsOfUseRouteImport } from './routes/_app.terms-of-use'
import { Route as AppWebmcpRouteImport } from './routes/_app.webmcp'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminSplatRouteImport } from './routes/admin.$'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AppArticleIdRouteImport } from './routes/_app.article.$id'
import { Route as AppAuthorsSlugRouteImport } from './routes/_app.authors.$slug'
import { Route as AppEditorChoiceSlugRouteImport } from './routes/_app.editor-choice.$slug'
import { Route as AppGamesIndexRouteImport } from './routes/_app.games.index'
import { Route as AppIntelligenceIndexRouteImport } from './routes/_app.intelligence.index'
import { Route as AppIntelligenceAnalyticsRouteImport } from './routes/_app.intelligence.analytics'
import { Route as AppIntelligenceCreateRouteImport } from './routes/_app.intelligence.create'
import { Route as AppIntelligenceLeaderboardRouteImport } from './routes/_app.intelligence.leaderboard'
import { Route as AppIntelligenceOnboardingRouteImport } from './routes/_app.intelligence.onboarding'
import { Route as AppIntelligenceSubscribeRouteImport } from './routes/_app.intelligence.subscribe'
import { Route as AppLearnArticlesIndexRouteImport } from './routes/_app.learn-articles.index'
import { Route as AppLearnArticlesSlugRouteImport } from './routes/_app.learn-articles.$slug'
import { Route as AppLearnIndexRouteImport } from './routes/_app.learn.index'
import { Route as AppLearnPathIdRouteImport } from './routes/_app.learn.$pathId'
import { Route as AppMarketsIndexRouteImport } from './routes/_app.markets.index'
import { Route as AppMarketsIdRouteImport } from './routes/_app.markets.$id'
import { Route as AppNewsAuthorSlugRouteImport } from './routes/_app.news-author.$slug'
import { Route as AppNewsCategoriesIndexRouteImport } from './routes/_app.news-categories.index'
import { Route as AppNewsCategoriesSlugRouteImport } from './routes/_app.news-categories.$slug'
import { Route as AppNewsIndexRouteImport } from './routes/_app.news.index'
import { Route as AppNewsSlugRouteImport } from './routes/_app.news.$slug'
import { Route as AppPodcastSlugRouteImport } from './routes/_app.podcast.$slug'
import { Route as AppPodcastsIndexRouteImport } from './routes/_app.podcasts.index'
import { Route as AppPolymarketIndexRouteImport } from './routes/_app.polymarket.index'
import { Route as AppPolymarketEventIdRouteImport } from './routes/_app.polymarket.$eventId'
import { Route as AppPredictionMarketsIndexRouteImport } from './routes/_app.prediction-markets.index'
import { Route as AppPredictionMarketsEventIdRouteImport } from './routes/_app.prediction-markets.$eventId'
import { Route as AppPressReleasesIndexRouteImport } from './routes/_app.press-releases.index'
import { Route as AppPressReleasesSlugRouteImport } from './routes/_app.press-releases.$slug'
import { Route as AppProfileIndexRouteImport } from './routes/_app.profile.index'
import { Route as AppProfileUserIdRouteImport } from './routes/_app.profile.$userId'
import { Route as AppSocialIndexRouteImport } from './routes/_app.social.index'
import { Route as AppTokensIndexRouteImport } from './routes/_app.tokens.index'
import { Route as AppTokensIdRouteImport } from './routes/_app.tokens.$id'
import { Route as AppTopicsIndexRouteImport } from './routes/_app.topics.index'
import { Route as AppTopicsSlugRouteImport } from './routes/_app.topics.$slug'
import { Route as AppWeeklyIndexRouteImport } from './routes/_app.weekly.index'
import { Route as AppWeeklyIdRouteImport } from './routes/_app.weekly.$id'
import { Route as AppGamesSlugIndexRouteImport } from './routes/_app.games.$slug.index'
import { Route as AppGamesSlugPlayRouteImport } from './routes/_app.games.$slug.play'
import { Route as AppIntelligenceAnalystsIndexRouteImport } from './routes/_app.intelligence.analysts.index'
import { Route as AppIntelligenceAnalystsIdRouteImport } from './routes/_app.intelligence.analysts.$id'
import { Route as AppIntelligenceForecastsIndexRouteImport } from './routes/_app.intelligence.forecasts.index'
import { Route as AppIntelligenceForecastsIdRouteImport } from './routes/_app.intelligence.forecasts.$id'
import { Route as AppIntelligencePostsIdRouteImport } from './routes/_app.intelligence.posts.$id'
import { Route as AppMarketsStocksSymbolRouteImport } from './routes/_app.markets.stocks.$symbol'
import { Route as AppPodcastsPodcastIdIndexRouteImport } from './routes/_app.podcasts.$podcastId.index'
import { Route as AppPodcastsPodcastIdEpisodesEpisodeIdRouteImport } from './routes/_app.podcasts.$podcastId.episodes.$episodeId'

const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const PlusRoute = PlusRouteImport.update({
            id: '/plus',path: '/plus',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppSplatRoute = AppSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => AppRoute
          })
const AppAboutRoute = AppAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => AppRoute
          })
const AppBookmarksRoute = AppBookmarksRouteImport.update({
            id: '/bookmarks',path: '/bookmarks',getParentRoute: () => AppRoute
          })
const AppDailyRoute = AppDailyRouteImport.update({
            id: '/daily',path: '/daily',getParentRoute: () => AppRoute
          })
const AppEditorialStandardsRoute = AppEditorialStandardsRouteImport.update({
            id: '/editorial-standards',path: '/editorial-standards',getParentRoute: () => AppRoute
          })
const AppFeedRoute = AppFeedRouteImport.update({
            id: '/feed',path: '/feed',getParentRoute: () => AppRoute
          })
const AppJoinRoute = AppJoinRouteImport.update({
            id: '/join',path: '/join',getParentRoute: () => AppRoute
          })
const AppLeaderboardRoute = AppLeaderboardRouteImport.update({
            id: '/leaderboard',path: '/leaderboard',getParentRoute: () => AppRoute
          })
const AppPremiumRoute = AppPremiumRouteImport.update({
            id: '/premium',path: '/premium',getParentRoute: () => AppRoute
          })
const AppPrivacyPolicyRoute = AppPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => AppRoute
          })
const AppSearchRoute = AppSearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => AppRoute
          })
const AppTermsOfUseRoute = AppTermsOfUseRouteImport.update({
            id: '/terms-of-use',path: '/terms-of-use',getParentRoute: () => AppRoute
          })
const AppWebmcpRoute = AppWebmcpRouteImport.update({
            id: '/webmcp',path: '/webmcp',getParentRoute: () => AppRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminSplatRoute = AdminSplatRouteImport.update({
            id: '/admin/$',path: '/admin/$',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AppArticleIdRoute = AppArticleIdRouteImport.update({
            id: '/article/$id',path: '/article/$id',getParentRoute: () => AppRoute
          })
const AppAuthorsSlugRoute = AppAuthorsSlugRouteImport.update({
            id: '/authors/$slug',path: '/authors/$slug',getParentRoute: () => AppRoute
          })
const AppEditorChoiceSlugRoute = AppEditorChoiceSlugRouteImport.update({
            id: '/editor-choice/$slug',path: '/editor-choice/$slug',getParentRoute: () => AppRoute
          })
const AppGamesIndexRoute = AppGamesIndexRouteImport.update({
            id: '/games/',path: '/games/',getParentRoute: () => AppRoute
          })
const AppIntelligenceIndexRoute = AppIntelligenceIndexRouteImport.update({
            id: '/intelligence/',path: '/intelligence/',getParentRoute: () => AppRoute
          })
const AppIntelligenceAnalyticsRoute = AppIntelligenceAnalyticsRouteImport.update({
            id: '/intelligence/analytics',path: '/intelligence/analytics',getParentRoute: () => AppRoute
          })
const AppIntelligenceCreateRoute = AppIntelligenceCreateRouteImport.update({
            id: '/intelligence/create',path: '/intelligence/create',getParentRoute: () => AppRoute
          })
const AppIntelligenceLeaderboardRoute = AppIntelligenceLeaderboardRouteImport.update({
            id: '/intelligence/leaderboard',path: '/intelligence/leaderboard',getParentRoute: () => AppRoute
          })
const AppIntelligenceOnboardingRoute = AppIntelligenceOnboardingRouteImport.update({
            id: '/intelligence/onboarding',path: '/intelligence/onboarding',getParentRoute: () => AppRoute
          })
const AppIntelligenceSubscribeRoute = AppIntelligenceSubscribeRouteImport.update({
            id: '/intelligence/subscribe',path: '/intelligence/subscribe',getParentRoute: () => AppRoute
          })
const AppLearnArticlesIndexRoute = AppLearnArticlesIndexRouteImport.update({
            id: '/learn-articles/',path: '/learn-articles/',getParentRoute: () => AppRoute
          })
const AppLearnArticlesSlugRoute = AppLearnArticlesSlugRouteImport.update({
            id: '/learn-articles/$slug',path: '/learn-articles/$slug',getParentRoute: () => AppRoute
          })
const AppLearnIndexRoute = AppLearnIndexRouteImport.update({
            id: '/learn/',path: '/learn/',getParentRoute: () => AppRoute
          })
const AppLearnPathIdRoute = AppLearnPathIdRouteImport.update({
            id: '/learn/$pathId',path: '/learn/$pathId',getParentRoute: () => AppRoute
          })
const AppMarketsIndexRoute = AppMarketsIndexRouteImport.update({
            id: '/markets/',path: '/markets/',getParentRoute: () => AppRoute
          })
const AppMarketsIdRoute = AppMarketsIdRouteImport.update({
            id: '/markets/$id',path: '/markets/$id',getParentRoute: () => AppRoute
          })
const AppNewsAuthorSlugRoute = AppNewsAuthorSlugRouteImport.update({
            id: '/news-author/$slug',path: '/news-author/$slug',getParentRoute: () => AppRoute
          })
const AppNewsCategoriesIndexRoute = AppNewsCategoriesIndexRouteImport.update({
            id: '/news-categories/',path: '/news-categories/',getParentRoute: () => AppRoute
          })
const AppNewsCategoriesSlugRoute = AppNewsCategoriesSlugRouteImport.update({
            id: '/news-categories/$slug',path: '/news-categories/$slug',getParentRoute: () => AppRoute
          })
const AppNewsIndexRoute = AppNewsIndexRouteImport.update({
            id: '/news/',path: '/news/',getParentRoute: () => AppRoute
          })
const AppNewsSlugRoute = AppNewsSlugRouteImport.update({
            id: '/news/$slug',path: '/news/$slug',getParentRoute: () => AppRoute
          })
const AppPodcastSlugRoute = AppPodcastSlugRouteImport.update({
            id: '/podcast/$slug',path: '/podcast/$slug',getParentRoute: () => AppRoute
          })
const AppPodcastsIndexRoute = AppPodcastsIndexRouteImport.update({
            id: '/podcasts/',path: '/podcasts/',getParentRoute: () => AppRoute
          })
const AppPolymarketIndexRoute = AppPolymarketIndexRouteImport.update({
            id: '/polymarket/',path: '/polymarket/',getParentRoute: () => AppRoute
          })
const AppPolymarketEventIdRoute = AppPolymarketEventIdRouteImport.update({
            id: '/polymarket/$eventId',path: '/polymarket/$eventId',getParentRoute: () => AppRoute
          })
const AppPredictionMarketsIndexRoute = AppPredictionMarketsIndexRouteImport.update({
            id: '/prediction-markets/',path: '/prediction-markets/',getParentRoute: () => AppRoute
          })
const AppPredictionMarketsEventIdRoute = AppPredictionMarketsEventIdRouteImport.update({
            id: '/prediction-markets/$eventId',path: '/prediction-markets/$eventId',getParentRoute: () => AppRoute
          })
const AppPressReleasesIndexRoute = AppPressReleasesIndexRouteImport.update({
            id: '/press-releases/',path: '/press-releases/',getParentRoute: () => AppRoute
          })
const AppPressReleasesSlugRoute = AppPressReleasesSlugRouteImport.update({
            id: '/press-releases/$slug',path: '/press-releases/$slug',getParentRoute: () => AppRoute
          })
const AppProfileIndexRoute = AppProfileIndexRouteImport.update({
            id: '/profile/',path: '/profile/',getParentRoute: () => AppRoute
          })
const AppProfileUserIdRoute = AppProfileUserIdRouteImport.update({
            id: '/profile/$userId',path: '/profile/$userId',getParentRoute: () => AppRoute
          })
const AppSocialIndexRoute = AppSocialIndexRouteImport.update({
            id: '/social/',path: '/social/',getParentRoute: () => AppRoute
          })
const AppTokensIndexRoute = AppTokensIndexRouteImport.update({
            id: '/tokens/',path: '/tokens/',getParentRoute: () => AppRoute
          })
const AppTokensIdRoute = AppTokensIdRouteImport.update({
            id: '/tokens/$id',path: '/tokens/$id',getParentRoute: () => AppRoute
          })
const AppTopicsIndexRoute = AppTopicsIndexRouteImport.update({
            id: '/topics/',path: '/topics/',getParentRoute: () => AppRoute
          })
const AppTopicsSlugRoute = AppTopicsSlugRouteImport.update({
            id: '/topics/$slug',path: '/topics/$slug',getParentRoute: () => AppRoute
          })
const AppWeeklyIndexRoute = AppWeeklyIndexRouteImport.update({
            id: '/weekly/',path: '/weekly/',getParentRoute: () => AppRoute
          })
const AppWeeklyIdRoute = AppWeeklyIdRouteImport.update({
            id: '/weekly/$id',path: '/weekly/$id',getParentRoute: () => AppRoute
          })
const AppGamesSlugIndexRoute = AppGamesSlugIndexRouteImport.update({
            id: '/games/$slug/',path: '/games/$slug/',getParentRoute: () => AppRoute
          })
const AppGamesSlugPlayRoute = AppGamesSlugPlayRouteImport.update({
            id: '/games/$slug/play',path: '/games/$slug/play',getParentRoute: () => AppRoute
          })
const AppIntelligenceAnalystsIndexRoute = AppIntelligenceAnalystsIndexRouteImport.update({
            id: '/intelligence/analysts/',path: '/intelligence/analysts/',getParentRoute: () => AppRoute
          })
const AppIntelligenceAnalystsIdRoute = AppIntelligenceAnalystsIdRouteImport.update({
            id: '/intelligence/analysts/$id',path: '/intelligence/analysts/$id',getParentRoute: () => AppRoute
          })
const AppIntelligenceForecastsIndexRoute = AppIntelligenceForecastsIndexRouteImport.update({
            id: '/intelligence/forecasts/',path: '/intelligence/forecasts/',getParentRoute: () => AppRoute
          })
const AppIntelligenceForecastsIdRoute = AppIntelligenceForecastsIdRouteImport.update({
            id: '/intelligence/forecasts/$id',path: '/intelligence/forecasts/$id',getParentRoute: () => AppRoute
          })
const AppIntelligencePostsIdRoute = AppIntelligencePostsIdRouteImport.update({
            id: '/intelligence/posts/$id',path: '/intelligence/posts/$id',getParentRoute: () => AppRoute
          })
const AppMarketsStocksSymbolRoute = AppMarketsStocksSymbolRouteImport.update({
            id: '/markets/stocks/$symbol',path: '/markets/stocks/$symbol',getParentRoute: () => AppRoute
          })
const AppPodcastsPodcastIdIndexRoute = AppPodcastsPodcastIdIndexRouteImport.update({
            id: '/podcasts/$podcastId/',path: '/podcasts/$podcastId/',getParentRoute: () => AppRoute
          })
const AppPodcastsPodcastIdEpisodesEpisodeIdRoute = AppPodcastsPodcastIdEpisodesEpisodeIdRouteImport.update({
            id: '/podcasts/$podcastId/episodes/$episodeId',path: '/podcasts/$podcastId/episodes/$episodeId',getParentRoute: () => AppRoute
          })





const AppRouteChildren = {
  AppSplatRoute: AppSplatRoute,AppAboutRoute: AppAboutRoute,AppBookmarksRoute: AppBookmarksRoute,AppDailyRoute: AppDailyRoute,AppEditorialStandardsRoute: AppEditorialStandardsRoute,AppFeedRoute: AppFeedRoute,AppJoinRoute: AppJoinRoute,AppLeaderboardRoute: AppLeaderboardRoute,AppPremiumRoute: AppPremiumRoute,AppPrivacyPolicyRoute: AppPrivacyPolicyRoute,AppSearchRoute: AppSearchRoute,AppTermsOfUseRoute: AppTermsOfUseRoute,AppWebmcpRoute: AppWebmcpRoute,AppIndexRoute: AppIndexRoute,AppArticleIdRoute: AppArticleIdRoute,AppAuthorsSlugRoute: AppAuthorsSlugRoute,AppEditorChoiceSlugRoute: AppEditorChoiceSlugRoute,AppIntelligenceAnalyticsRoute: AppIntelligenceAnalyticsRoute,AppIntelligenceCreateRoute: AppIntelligenceCreateRoute,AppIntelligenceLeaderboardRoute: AppIntelligenceLeaderboardRoute,AppIntelligenceOnboardingRoute: AppIntelligenceOnboardingRoute,AppIntelligenceSubscribeRoute: AppIntelligenceSubscribeRoute,AppLearnArticlesSlugRoute: AppLearnArticlesSlugRoute,AppLearnPathIdRoute: AppLearnPathIdRoute,AppMarketsIdRoute: AppMarketsIdRoute,AppNewsAuthorSlugRoute: AppNewsAuthorSlugRoute,AppNewsCategoriesSlugRoute: AppNewsCategoriesSlugRoute,AppNewsSlugRoute: AppNewsSlugRoute,AppPodcastSlugRoute: AppPodcastSlugRoute,AppPolymarketEventIdRoute: AppPolymarketEventIdRoute,AppPredictionMarketsEventIdRoute: AppPredictionMarketsEventIdRoute,AppPressReleasesSlugRoute: AppPressReleasesSlugRoute,AppProfileUserIdRoute: AppProfileUserIdRoute,AppTokensIdRoute: AppTokensIdRoute,AppTopicsSlugRoute: AppTopicsSlugRoute,AppWeeklyIdRoute: AppWeeklyIdRoute,AppGamesIndexRoute: AppGamesIndexRoute,AppIntelligenceIndexRoute: AppIntelligenceIndexRoute,AppLearnArticlesIndexRoute: AppLearnArticlesIndexRoute,AppLearnIndexRoute: AppLearnIndexRoute,AppMarketsIndexRoute: AppMarketsIndexRoute,AppNewsCategoriesIndexRoute: AppNewsCategoriesIndexRoute,AppNewsIndexRoute: AppNewsIndexRoute,AppPodcastsIndexRoute: AppPodcastsIndexRoute,AppPolymarketIndexRoute: AppPolymarketIndexRoute,AppPredictionMarketsIndexRoute: AppPredictionMarketsIndexRoute,AppPressReleasesIndexRoute: AppPressReleasesIndexRoute,AppProfileIndexRoute: AppProfileIndexRoute,AppSocialIndexRoute: AppSocialIndexRoute,AppTokensIndexRoute: AppTokensIndexRoute,AppTopicsIndexRoute: AppTopicsIndexRoute,AppWeeklyIndexRoute: AppWeeklyIndexRoute,AppGamesSlugPlayRoute: AppGamesSlugPlayRoute,AppIntelligenceAnalystsIdRoute: AppIntelligenceAnalystsIdRoute,AppIntelligenceForecastsIdRoute: AppIntelligenceForecastsIdRoute,AppIntelligencePostsIdRoute: AppIntelligencePostsIdRoute,AppMarketsStocksSymbolRoute: AppMarketsStocksSymbolRoute,AppGamesSlugIndexRoute: AppGamesSlugIndexRoute,AppIntelligenceAnalystsIndexRoute: AppIntelligenceAnalystsIndexRoute,AppIntelligenceForecastsIndexRoute: AppIntelligenceForecastsIndexRoute,AppPodcastsPodcastIdIndexRoute: AppPodcastsPodcastIdIndexRoute,AppPodcastsPodcastIdEpisodesEpisodeIdRoute: AppPodcastsPodcastIdEpisodesEpisodeIdRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  AppRoute: AppRouteWithChildren,PlusRoute: PlusRoute,AdminSplatRoute: AdminSplatRoute,AdminIndexRoute: AdminIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)